import { KitType } from '@repo/types';
import { Typography } from '@repo/ui';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import useFeature from 'services/features/useFeature';
import ConditionMetricCard from '../../ConditionMetricCard';
import FlaggedMetricsCount from '../../FlaggedMetricsCount';
import ConditionLinkCard from '../../NewConditionMetricsList/ConditionLinkCard';
import styles from '../ConditionsEducationalModal.module.css';
import { CARD_CONFIG } from '../utils/sensitiveSlideConfig';

export default function SensitiveMetricFlagsSlide() {
  const { isFeatureEnabled: isGutXAxisEnabled } = useFeature('gut_x_axis');
  const { currentKitType = KitType.STOOL } = useCurrentKitAndTinyAccount();

  const showGutXAxis = isGutXAxisEnabled && currentKitType === KitType.STOOL;

  const { name, evaluationCounts } = CARD_CONFIG[currentKitType];

  return (
    <>
      <Typography variant='heading-l' className={styles.headingText}>
        Flags in conditions you're not experiencing? Don't worry.
      </Typography>
      {showGutXAxis ? (
        <ConditionLinkCard
          name={name}
          trailing={<FlaggedMetricsCount flagged={3} total={10} />}
          className={styles.conditionLinkCard}
        />
      ) : (
        <div className={styles.legacyCardWrapper}>
          <ConditionMetricCard
            title={name}
            evaluationCounts={evaluationCounts}
          />
        </div>
      )}

      <Typography
        variant='body-s'
        className={styles.headingText}
        color='warm-grey-700'
      >
        Remember — associations should be treated as informational, not
        diagnostic. It doesn't mean you have the condition or will develop it.
      </Typography>
    </>
  );
}
